var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"chart-title"},[_c('icons',{staticClass:"chart-title__icon",attrs:{"icon":_vm.icon,"color":_vm.color}}),_c('span',[_vm._v(" "+_vm._s(_vm.title)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }